"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LinksCarouselLayout = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const LinksCarouselLayout = (param)=>{
    let { data, debug, modulePosition } = param;
    const isMobile = (0, _presentationHooks.useIsMobile)();
    const { translations } = (0, _hooks.useTranslations)();
    const { title, linkItems } = data;
    const { getTestId } = (0, _testidGenerator.default)();
    const carouselOptions = (0, _react.useMemo)(()=>({
            width: isMobile ? _constants.CAROUSEL_MOBILE_WIDTH : _constants.CAROUSEL_DESKTOP_WIDTH,
            hasFocusableSlides: true,
            navigation: {
                position: 'outside',
                showArrows: !isMobile && linkItems.length > 5,
                size: 'medium'
            },
            pagination: {
                show: false
            },
            slider: {
                loop: false,
                slides: {
                    perView: 2.5,
                    spacing: 10
                },
                breakpoints: {
                    ["(min-width: ".concat(_constants.CAROUSEL_SM_BREAKPOINT, ")")]: {
                        slides: {
                            perView: 6,
                            spacing: 20
                        }
                    }
                }
            }
        }), [
        isMobile,
        linkItems.length
    ]);
    if (linkItems.length < 1) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: 'EditorialLinkCarousel'
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.LINKS_CAROUSEL_ROOT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h4",
                textAlign: "center",
                "data-testid": getTestId(_constants.LINKS_CAROUSEL_TITLE),
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
                ...carouselOptions,
                id: _constants.LINKS_CAROUSEL_ID,
                children: linkItems.map((item)=>{
                    var _item_link;
                    var _item_link_relativeUrl;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
                            buttonText: translations.view,
                            imageUrl: item.imageUrl,
                            relativeUrl: (_item_link_relativeUrl = (_item_link = item.link) === null || _item_link === void 0 ? void 0 : _item_link.relativeUrl) !== null && _item_link_relativeUrl !== void 0 ? _item_link_relativeUrl : '',
                            title: item.title
                        })
                    }, item.title);
                })
            })
        ]
    });
};
exports.LinksCarouselLayout = LinksCarouselLayout;
